module.exports = __webpack_public_path__ + "static/media/obstruido 1.8549589b.svg";